import { __decorate, __metadata } from "tslib";
import { injectable } from "inversify";
import { UserLocalizationConfigStorage } from "./UserLocalizationConfigStorage";
import { MutableStore } from "../../store";
let UserLocalizationConfigStore = class UserLocalizationConfigStore extends MutableStore {
    constructor(storage) {
        super(storage.getValue() ?? {
            selectedLocale: undefined,
            selectedCurrency: undefined,
        });
        this.storage = storage;
    }
    registerListeners() {
        this.storageSubscription ??=
            this.value$.subscribe(state => this.storage.setValue(state));
    }
    setCurrentLocale(locale) {
        if (this.value.selectedLocale?.equals(locale))
            return;
        this.mutate(state => {
            state.selectedLocale = locale;
            return state;
        });
    }
    setCurrentCurrency(currency) {
        if (this.value.selectedCurrency == currency)
            return;
        this.mutate(state => {
            state.selectedCurrency = currency;
            return state;
        });
    }
};
UserLocalizationConfigStore = __decorate([
    injectable(),
    __metadata("design:paramtypes", [UserLocalizationConfigStorage])
], UserLocalizationConfigStore);
export { UserLocalizationConfigStore };
//# sourceMappingURL=UserLocalizationConfigStore.js.map